// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/coret/CoretChannelFeeSettings.module.css';
import {getCoretChannelAccess, removeCoretChannelFee, setCoretChannelFee} from '@app/features/coret/CoretMediaApi';
import {useEffect, useState} from 'react';

export function CoretChannelFeeSettings({channelId}: {channelId: string}) {
	const [enabled, setEnabled] = useState(false);
	const [price, setPrice] = useState(1);
	const [mode, setMode] = useState<'permanent' | 'per_entry'>('permanent');
	const [busy, setBusy] = useState(false);
	const [message, setMessage] = useState('');

	useEffect(() => {
		let active = true;
		void getCoretChannelAccess(channelId)
			.then(({fee}) => {
				if (!active || !fee) return;
				setEnabled(true);
				setPrice(fee.price);
				setMode(fee.mode);
			})
			.catch(() => active && setMessage('Não foi possível carregar a taxa desta sala.'));
		return () => {
			active = false;
		};
	}, [channelId]);

	const save = async () => {
		setBusy(true);
		setMessage('Salvando…');
		try {
			if (enabled) await setCoretChannelFee(channelId, Math.max(1, Math.floor(price)), mode);
			else await removeCoretChannelFee(channelId);
			setMessage(enabled ? 'Taxa da sala configurada.' : 'Acesso gratuito restaurado.');
		} catch (error) {
			setMessage(error instanceof Error ? error.message : 'Não foi possível salvar a taxa.');
		} finally {
			setBusy(false);
		}
	};

	return (
		<section className={styles.section} aria-labelledby="coret-channel-fee-heading">
			<div>
				<h3 id="coret-channel-fee-heading">Taxa de acesso</h3>
				<p>Exija pontos antes de entrar nesta call ou abrir este canal de texto.</p>
			</div>
			<label className={styles.toggle}>
				<input type="checkbox" checked={enabled} onChange={(event) => setEnabled(event.target.checked)} />
				Cobrar para acessar esta sala
			</label>
			{enabled && (
				<div className={styles.fields}>
					<label>Pontos<input type="number" min={1} step={1} value={price} onChange={(event) => setPrice(Number(event.target.value))} /></label>
					<label>Forma de cobrança<select value={mode} onChange={(event) => setMode(event.target.value as 'permanent' | 'per_entry')}><option value="permanent">Pagamento único</option><option value="per_entry">A cada entrada</option></select></label>
				</div>
			)}
			<button type="button" onClick={() => void save()} disabled={busy}>{busy ? 'Salvando…' : 'Salvar taxa'}</button>
			{message && <p className={styles.status} role="status">{message}</p>}
		</section>
	);
}
